import { useState, useEffect, useRef } from 'react';

const videos = [
  {
    id: 'b6-X0mXz6Hw',
    embedUrl: 'https://www.youtube.com/embed/b6-X0mXz6Hw?enablejsapi=1',
    title: 'Featured Video 1'
  },
  {
    id: 'Y44ZLFoZicE',
    embedUrl: 'https://www.youtube.com/embed/Y44ZLFoZicE?enablejsapi=1',
    title: 'Featured Video 2'
  },
  {
    id: 'gUHjLLVFb8A',
    embedUrl: 'https://www.youtube.com/embed/gUHjLLVFb8A?enablejsapi=1',
    title: 'Featured Video 3'
  }
];

const FeaturedOn = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const playersRef = useRef({});

  useEffect(() => {
    const initPlayers = () => {
      if (!window.YT || !window.YT.Player) return;

      videos.forEach((video, idx) => {
        const iframeId = `yt-player-${idx}`;
        if (!playersRef.current[iframeId]) {
          try {
            playersRef.current[iframeId] = new window.YT.Player(iframeId, {
              events: {
                onStateChange: (event) => {
                  // YT.PlayerState.PLAYING (1), BUFFERING (3)
                  if (
                    event.data === window.YT.PlayerState.PLAYING ||
                    event.data === window.YT.PlayerState.BUFFERING
                  ) {
                    setIsPlaying(true);
                  } else {
                    setIsPlaying(false);
                  }
                }
              }
            });
          } catch (e) {
            // Player initialization handling
          }
        }
      });
    };

    if (!window.YT) {
      const tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      const firstScriptTag = document.getElementsByTagName('script')[0];
      if (firstScriptTag && firstScriptTag.parentNode) {
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      } else {
        document.head.appendChild(tag);
      }
      window.onYouTubeIframeAPIReady = initPlayers;
    } else {
      initPlayers();
    }
  }, []);

  // Autoscroll every 5 seconds if video is not playing and user is not hovering
  useEffect(() => {
    if (isPlaying || isHovered) return;

    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % videos.length);
    }, 5000);

    return () => clearInterval(timer);
  }, [isPlaying, isHovered]);

  const prevSlide = () => {
    setIsPlaying(false);
    setCurrentIndex((prev) => (prev === 0 ? videos.length - 1 : prev - 1));
  };

  const nextSlide = () => {
    setIsPlaying(false);
    setCurrentIndex((prev) => (prev === videos.length - 1 ? 0 : prev + 1));
  };

  const goToSlide = (idx) => {
    setIsPlaying(false);
    setCurrentIndex(idx);
  };

  return (
    <section className="featured-on-section">
      <div className="featured-on-container fade-in">
        <div className="section-label" style={{ textAlign: 'center' }}>Media & Highlights</div>
        <h2 className="featured-on-title">Featured On</h2>
        
        <div 
          className="slideshow-wrapper"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <button 
            type="button"
            className="slideshow-btn prev-btn" 
            onClick={prevSlide}
            aria-label="Previous Video"
          >
            &#10094;
          </button>

          <div className="slideshow-track-container">
            <div 
              className="slideshow-track" 
              style={{ transform: `translateX(-${currentIndex * 100}%)` }}
            >
              {videos.map((video, idx) => (
                <div key={video.id} className="slide-item">
                  <div className="video-responsive">
                    <iframe
                      id={`yt-player-${idx}`}
                      src={video.embedUrl}
                      title={video.title}
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      allowFullScreen
                    ></iframe>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <button 
            type="button"
            className="slideshow-btn next-btn" 
            onClick={nextSlide}
            aria-label="Next Video"
          >
            &#10095;
          </button>
        </div>

        <div className="slideshow-dots">
          {videos.map((_, idx) => (
            <button
              key={idx}
              type="button"
              className={`dot ${idx === currentIndex ? 'active' : ''}`}
              onClick={() => goToSlide(idx)}
              aria-label={`Go to video ${idx + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedOn;
